import { forwardRef, useState } from 'react';
import { ButtonBase as MuiButtonBase } from '@mui/material';
import { Typography } from '../Typography';
import { TextField } from './TextField';
import type { TextFieldProps } from './TextField';

export interface PasswordFieldProps extends TextFieldProps {
  /** Label for show password base (text) button */
  showPasswordButtonLabelShow: string;
  /** Label for show password base (text) button */
  showPasswordButtonLabelHide: string;
  /** Chars counter label */
  charsCounterLabel: string;
}

export const PasswordField = forwardRef<HTMLInputElement, PasswordFieldProps>(
  (
    { showPasswordButtonLabelShow, showPasswordButtonLabelHide, charsCounterLabel, ...props },
    ref,
  ) => {
    const [showPassword, setShowPassword] = useState(false);

    const toggleShowPassword = () => setShowPassword((s) => !s);

    return (
      <TextField
        ref={ref}
        {...props}
        type={showPassword ? 'text' : 'password'}
        InputProps={{
          endAdornment: (
            <>
              <Typography
                sx={{
                  position: 'absolute',
                  top: -18,
                  right: 0,
                  color: (props.value as string)?.length < 6 ? 'grey.dark' : 'success.dark',
                }}
                variant="body2"
              >
                {`${(props.value as string)?.length || 0} ${charsCounterLabel}`}
              </Typography>
              <MuiButtonBase onClick={toggleShowPassword} sx={{ px: 1, color: 'grey.dark' }}>
                <Typography
                  variant="body2"
                  style={{
                    wordBreak: 'keep-all',
                  }}
                >
                  {showPassword ? showPasswordButtonLabelHide : showPasswordButtonLabelShow}
                </Typography>
              </MuiButtonBase>
            </>
          ),
        }}
      />
    );
  },
);
